<div class="navigation">
  <ul class="tabs">
    <ng-container *ngFor="let tab of tabs">
      <li (click)="onTabClick(tab)" [ngClass]="{ active: tab.key === activeTab }">
        <p>{{ tab.label }}</p>
      </li>
    </ng-container>
  </ul>
</div>
